module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "info__name"
  }, [_vm._v(_vm._s(_vm.name)), _c('br'), _vm._v(_vm._s(_vm.surname))]), _c('p', {
    staticClass: "info__age"
  }, [_vm._v(_vm._s(_vm.age))]), (_vm.showButton) ? _c('Button', {
    attrs: {
      "link": _vm.index === 0,
      "to": _vm.to,
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_vm._v(_vm._s(_vm.editText))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-082d8894","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/info/Info.vue
// module id = 67d86dde3589c8891ea9
// module chunks = 89